// extracted by mini-css-extract-plugin
export default {"indicator":"Pe9Pk","blink":"gvAQt"};